var _path, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifiedBytePattern = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--sscs-interactive)",
  d: "m12 2.5 7.5 2.7v5.4c0 4.7-3.1 8.7-7.5 10.9-4.4-2.2-7.5-6.2-7.5-10.9V5.2Z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 9.6,
  cy: 9.4,
  r: 1.25,
  fill: "var(--sscs-text-inverse)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.4,
  cy: 9.4,
  r: 1.25,
  fill: "var(--sscs-text-inverse)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 9.6,
  cy: 13.4,
  r: 1.25,
  fill: "var(--sscs-text-inverse)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 14.4,
  cy: 13.4,
  r: 1.25,
  fill: "var(--sscs-text-inverse)"
})));
export default SvgVerifiedBytePattern;